import React from 'react';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router';

import {title} from 'lib/head';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import CenteredPage from 'client/Layout/CenteredPage';

import SignUpForm from './SignUpForm/SignUpForm.react';
import NewSignUpPage from './NewSignUp/NewSignUpPage';

const Form = withRouter(SignUpForm);

interface SignUpPageProps {
  location?: {
    query?: {
      accountType?: string;
    };
  };
}

const SignUpPage = ({location}: SignUpPageProps) => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('new_signup_flow');

  if (isLoading) {
    return null;
  }

  if (isFeatureEnabled) {
    return <NewSignUpPage accountType={location?.query?.accountType} />;
  }

  return (
    <>
      <Helmet>{title('Sign Up | Albert')}</Helmet>
      <CenteredPage>
        <Form />
      </CenteredPage>
    </>
  );
};

export default SignUpPage;
